/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import { HOME_CONTENT_PAGE } from '../data/siteData';

export function getHomeLink(label, fallback = '#') {
  const link = (HOME_CONTENT_PAGE.links || []).find((item) => item.label === label);

  return link?.href || fallback;
}
